import { OrganizationDomainEntity } from '../entities/OrganizationDomain';
import { authResource } from './Auth';
export const OrganizationDomainResource = authResource({
    path: '/organizations/:organizationId/domains/:organizationDomainId',
    schema: OrganizationDomainEntity
});
